import React from 'react'
import Bookmarkable from '../components/Bookmarkable'

export default class ContentAdsList extends React.Component {
  componentDidMount() {
    new Bookmarkable()
  }

  renderSyncError() {
    return (
      <div className="d-flex flex-column col-12 pt-3 ml-3 u-wrap">
        <i>IDS ran into an error trying to place this ad in the publication .indd file</i>
      </div>
    );
  }

  render() {
    const rows = this.props.data.map((ad) => {
      return (
        <a key={ad.index} className="list-group-item u-hover--raised pl-0 pr-0" href={ad.href}>
          <div className="d-flex w-100 align-items-center cursor-pointer row u-wrap">
            <div className={`list-status-side-bar ${ad.colorClass}`} title={ad.status} />
            <div className="d-flex flex-column col-1 ml-3 js-bookmark" data-id={ad.bookmarkableId}>
              <i className="material-icons">bookmark_border</i>
            </div>
            <div className="d-flex flex-column col-9 col-md-5 col-lg-5">
              {ad.clientName}
              <small className="grey-text u-wrap">{ad.filename}</small>
            </div>
            <div className="d-none d-md-flex flex-column grey-text col u-wrap">
              <small>{ad.size}</small>
              <small>{ad.location}</small>
            </div>
            <div className="d-none d-md-flex flex-column grey-text col-2 u-wrap">
              <small>{ad.pageHeader}</small>
              <small>{ad.headline}</small>
            </div>
            <small className="d-none d-lg-flex flex-column grey-text col u-wrap align-items-end" title={ad.modifiedAt}>
              {ad.formattedModifiedAt}
            </small>
            <div className="d-flex flex-column col align-items-end">
              <i className="material-icons">keyboard_arrow_right</i>
            </div>
            { ad.idsSyncError && this.renderSyncError() }
          </div>
        </a>
      )
    })

    return (
      <ul className="list-group list-group-flush">
        {rows}
      </ul>
    )
  }
}
